import { SET_PRODUCT_LIST_TOTAL, SET_PAGE_LIMIT } from "../action-types/plp";

export const setProductListTotal = (productListTotal: number) => ({
  type: SET_PRODUCT_LIST_TOTAL,
  payload: productListTotal,
});

export const setPageLimit = (pageLimit: number) => ({
  type: SET_PAGE_LIMIT,
  payload: pageLimit,
});
